import { api } from "@/lib/api";

// Téléchargement authentifié (Bearer) → Blob → URL temporaire. Le jeton n'apparaît jamais dans une URL.
export async function openAuthenticatedPdf(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const type = filename?.endsWith(".csv") ? "text/csv" : "application/pdf";
  const url = URL.createObjectURL(new Blob([data], { type }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "document.pdf";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
